// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import * as Yup from 'yup';
import 'yup-phone';

// profile form Validation Schema

const profileFormValidationSchema = Yup.object().shape({
  Name: Yup.string()
    .nullable()
    .required('Full Name is required')
    .max(128, 'Full Name length must be less than or equal to 128 characters long'),
  UserEmail: Yup.string().required('Email is required').email('Email is invalid'),
  PhoneNumber: Yup.string()
    .phone(['US', 'CA'], false, 'Please enter a valid phone number')
    .required('A phone number is required'),
  Company: Yup.string().max(128, 'Company Name length must be less than or equal to 128 characters long'),
  Position: Yup.string().max(128, 'Position length must be less than or equal to 128 characters long'),
  BillingAddress: Yup.string()
    .required('Billing Address is required')
    .max(128, 'Billing Address length must be less than or equal to 128 characters long'),
  AddressLine2: Yup.string().max(128, 'AddressLine2 length must be less than or equal to 128 characters long'),
  City: Yup.string()
    .required('City is required')
    .max(128, 'City Name length must be less than or equal to 128 characters long'),
  StateOrProvince: Yup.string()
    .required('State / Province is required')
    .max(128, 'State / Province length must be less than or equal to 128 characters long'),
  ZipOrPostalCode: Yup.string()
    .required('Zip / Postal Code is required')
    .max(128, 'Zip / Postal Code length must be less than or equal to 128 characters long'),
  Country: Yup.string()
    .required('Country is required')
    .max(128, 'Country length must be less than or equal to 128 characters long'),
});

export default profileFormValidationSchema;
